import Link from "next/link"
import Image from "next/image"
import { Phone, Mail, MapPin } from "lucide-react"

export default function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Information */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <Image src="https://rgvfkcfnfbtqyjlrvynz.supabase.co/storage/v1/object/public/vendor-assets/vendor-assets/logo-white.png" alt="MenuMate logo" width={20} height={20} className="h-5 w-5 object-contain" />
              <h3 className="font-semibold text-lg">menumate.in</h3>
            </div>
            <p className="text-sm text-gray-600">
              Empowering caterers and food businesses with digital solutions for order management, inventory tracking, and business growth.
            </p>
            <div className="space-y-2 text-sm text-gray-600">
              <p className="font-medium">GETBEGA TECH PRIVATE LIMITED</p>
              <p>CIN: U62011KA2024PTC194582</p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <Phone className="h-4 w-4" />
                <a href="tel:+918904885993" className="hover:text-white transition-colors">
                  +91 89048 85993
                </a>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-600">
                <Mail className="h-4 w-4" />
                <a href="mailto:support@menumate.in" className="hover:text-white transition-colors">
                  support@menumate.in
                </a>
              </div>
              <div className="flex items-start gap-2 text-sm text-gray-600">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <div>
                  {/* <p>10th Main Road, 2nd Stage,</p> */}
                  {/* <p>BTM Layout,</p> */}
                  <p>Banaglore - 560001</p>
                  <p>Karnataka, India</p>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Quick Links</h3>
            <div className="space-y-2">
              <Link href="/about" className="block text-sm text-gray-400 hover:text-white transition-colors">
                About MenuMate
              </Link>
              <Link href="/contact" className="block text-sm text-gray-400 hover:text-white transition-colors">
                Contact & Support
              </Link>
              <Link href="/#features" className="block text-sm text-gray-400 hover:text-white transition-colors">
                Features
              </Link>
              <Link href="/#pricing" className="block text-sm text-gray-400 hover:text-white transition-colors">
                Pricing
              </Link>
            </div>
          </div>

          {/* Legal & Policies */}
          <div className="space-y-4">
            <h3 className="font-semibold text-lg">Legal & Policies</h3>
            <div className="space-y-2">
              <Link href="/privacy-policy" className="block text-sm text-gray-400 hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link href="/terms-and-conditions" className="block text-sm text-gray-400 hover:text-white transition-colors">
                Terms & Conditions
              </Link>
              <Link href="/cookie-policy" className="block text-sm text-gray-400 hover:text-white transition-colors">
                Cookie Policy
              </Link>
              <Link href="/cancellation-and-refund" className="block text-sm text-gray-400 hover:text-white transition-colors">
                Refund Policy
              </Link>
              <Link href="/shipping-and-delivery" className="block text-sm text-gray-400 hover:text-white transition-colors">
                Shipping Policy
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-400">
              © {new Date().getFullYear()} GETBEGA TECH PRIVATE LIMITED. All rights reserved.
            </div>
            <div className="flex items-center gap-4 text-sm text-gray-400">
              <span>Registered in India</span>
              <span>•</span>
              <a href="mailto:privacy@menumate.in" className="hover:text-white transition-colors">
                Data Protection Officer
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}